import { render, staticRenderFns } from "./DoctorsFilterIgnorePrefs.vue?vue&type=template&id=a973acfc&scoped=true&"
import script from "./DoctorsFilterIgnorePrefs.vue?vue&type=script&lang=ts&"
export * from "./DoctorsFilterIgnorePrefs.vue?vue&type=script&lang=ts&"
import style0 from "./DoctorsFilterIgnorePrefs.vue?vue&type=style&index=0&id=a973acfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a973acfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a973acfc')) {
      api.createRecord('a973acfc', component.options)
    } else {
      api.reload('a973acfc', component.options)
    }
    module.hot.accept("./DoctorsFilterIgnorePrefs.vue?vue&type=template&id=a973acfc&scoped=true&", function () {
      api.rerender('a973acfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/DoctorsFilterIgnorePrefs.vue"
export default component.exports